import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import "react-table/react-table.css";

export default class TBLUsuarios extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.columns = [
      {
        Header: "Ativo",
        accessor: "ativo",
        Cell: (props) => <p>{props.value ? "Sim" : "Não"}</p>,
        className: "center",
      },
      {
        Header: "Email",
        accessor: "email",
        className: "center",
      },
      {
        Header: "Tipo",
        accessor: "tipo",
        className: "center",
      },
      {
        Header: "Ações",
        Cell: (row) => (
          <div>
            <Button
              size="sm"
              style={{ marginRight: 4 }}
              onClick={() => this.gerenciarAcoes("editar", row.row._original)}
            >
              <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
            </Button>
            <Button
              size="sm"
              variant="danger"
              onClick={() => this.gerenciarAcoes("deletar", row.row._original)}
            >
              <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
            </Button>
          </div>
        ),
        className: "center",
      },
    ];
  }

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "editar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    return (
      <ReactTable
        data={this.props.data}
        columns={this.columns}
        resizable={false}
        showPagination={this.props.showPagination}
        defaultPageSize={10}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando usuários..."
        noDataText="Nenhum usuário encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLUsuarios.propTypes = {
  data: PropTypes.array,
  showPagination: PropTypes.bool,
  numRows: PropTypes.number,
  dataCallback: PropTypes.func,
};
